function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import React from "react";
import PropTypes from "prop-types";
import { Carousel } from "@xo-union/ui-carousel";
import { ProductCard } from "../../index.js";
import styles from "./styles.css";
import { compose } from "@xo-union/react-css-modules";
var TopPickCarousel = function TopPickCarousel(_ref) {
  var products = _ref.products,
    favoriteComponent = _ref.favoriteComponent,
    layoutProps = _ref.layoutProps;
  var renderProductCard = function renderProductCard(product) {
    return /*#__PURE__*/React.createElement(ProductCard, {
      key: product.id,
      imageProps: product.imageProps,
      product: product,
      favoriteComponent: favoriteComponent,
      layoutProps: _objectSpread(_objectSpread({}, layoutProps), {}, {
        source: "top pick carousel",
        position: layoutProps.position,
        resultsCount: layoutProps.pagination.total_count,
        pageCount: layoutProps.current_page
      })
    });
  };
  var styleMapper = compose(styles);
  return /*#__PURE__*/React.createElement(React.Fragment, null, (products === null || products === void 0 ? void 0 : products.length) < 2 && null, (products === null || products === void 0 ? void 0 : products.length) >= 2 && window.innerWidth < 768 && /*#__PURE__*/React.createElement("div", {
    className: styles.topPickCarouselContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: "editorial ".concat(styles.title)
  }, "Top Picks"), /*#__PURE__*/React.createElement(Carousel, {
    gutter: 8,
    minSlideWidth: 147,
    maxSlideWidth: 167,
    renderNextButton: function renderNextButton() {
      return null;
    },
    renderPrevButton: function renderPrevButton() {
      return null;
    },
    classes: styleMapper
  }, _mapInstanceProperty(products).call(products, function (product) {
    return renderProductCard(product);
  }))));
};
process.env.NODE_ENV !== "production" ? TopPickCarousel.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    relativeUrl: PropTypes.string.isRequired,
    imageProps: PropTypes.shape({
      desktopWidth: PropTypes.number,
      desktopHeight: PropTypes.number,
      mobileWidth: PropTypes.number,
      mobileHeight: PropTypes.number,
      alt: PropTypes.string,
      image: PropTypes.string // Assuming `image` is used elsewhere
    }).isRequired
  })).isRequired
} : void 0;
export default TopPickCarousel;